import React from 'react'
import CenterText from './nav-bar/CenterText'
import SearchInput from './nav-bar/SearchInput'
import UserInfo from './nav-bar/UserInfo'
import {navbarList} from '../../utils/Index'
import {NavLink} from 'react-router-dom'
import MainLogoImg from '../defaults/MainLogoImg'
import SymbolLogoImg from '../defaults/SymbolLogoImg'

/**
 * @desc Type 3 of NavBar
 * @information
 * 1. Left: GIVU
 * 2. Center: Navigation List
 * 3. Right: Search, UserInfo
 */
const NavBarType03 = () => {
  const leftNavBar = navbarList.filter((item, index) => index < 2)
  const rightNavBar = navbarList.filter((item, index) => index > 1)
  return (
    <>
      <div className='w-full h-16 flex items-center justify-between shadow-sm text-center bg-[#333333] sticky top-0 z-10'>
        <div className='w-full h-full flex gap-6 justify-between'>
          <SymbolLogoImg />
          <div className='h-full flex min-w-[120px] ml-3 flex-auto justify-center items-center text-slate-50 bg-inherit font-semibold text-base'>
            {
              /* Rotuer Loop */
              leftNavBar.map((item, index) => (
                <div className='h-full nav-link-wrap min-w-[120px] border-none' key={index}>
                  <NavLink
                    to={item.path}
                    className='block h-full p-2 pt-5 transition-all no-underline hover:bg-[#f9fafb] hover:text-[#333333] hover:underline leading-8'
                  >
                    {item.title}
                  </NavLink>
                  <div
                    className='flex flex-col min-w-fit relative opacity-95 z-10 shadow-lg bg-[#333333]'
                    key={item.title}
                  ></div>
                </div>
              ))
            }
            <div className='h-full nav-link-wrap min-w-[120px] border-none'>
              <MainLogoImg />
            </div>
            {
              /* Rotuer Loop */
              rightNavBar.map((item, index) => (
                <div className='h-full nav-link-wrap min-w-[120px] border-none' key={index}>
                  <NavLink
                    to={item.path}
                    className='block h-full p-2 pt-5 transition-all no-underline hover:bg-[#f9fafb] hover:text-[#333333] hover:underline leading-8'
                  >
                    {item.title}
                  </NavLink>
                  <div
                    className='flex flex-col min-w-fit relative opacity-95 z-10 shadow-lg bg-[#333333]'
                    key={item.title}
                  ></div>
                </div>
              ))
            }
          </div>

          <div className='flex flex-end justify-end gap-4 mr-5'>
            <SearchInput />
            <UserInfo />
          </div>
        </div>
      </div>
    </>
  )
}

export default NavBarType03
